/* eslint-disable indent */
import {
  take,
  call,
  put,
  all,
  fork,
  takeLatest,
  select,
} from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { getCategoriesWithUncategorized } from 'sagas/api/category';
import {
  LIBRARY_ITEM_LIST_ITEM_REQUEST,
  LIBRARY_ITEM_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST,
  LIBRARY_ITEM_PAGE_REQUEST,
  LIBRARY_ITEM_SET_FILTER_ITEM,
  LIBRARY_ITEM_ON_CHANGE_OUTLET_IDS,
  LIBRARY_ITEM_ITEM_LIST_EXPORT,
  LIBRARY_ITEM_ITEM_LIST_TEMPLATE,
  LIBRARY_ITEM_ON_CLICK_CANCEL,
  LIBRARY_ITEM_ON_CLICK_BTN_ITEM_VARIANT,
  LIBRARY_ITEM_ON_CANCEL_ITEM_VARIANT_MODAL,
  LIBRARY_ITEM_ON_CONFIRM_ITEM_VARIANT_MODAL,
  LIBRARY_ITEM_ON_CONFIRM_SALES_TYPE_MODAL,
  LIBRARY_ITEM_ON_CLICK_BTN_SALES_TYPE,
  LIBRARY_ITEM_ON_CANCEL_SALES_TYPE_MODAL,
  LIBRARY_ITEM_ON_CLICK_BTN_ITEM_TRACKING,
  LIBRARY_ITEM_ON_CLICK_BTN_COGS_TRACKING,
  LIBRARY_ITEM_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL,
  LIBRARY_ITEM_ON_CANCEL_COGS_MODAL,
  LIBRARY_ITEM_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL,
  LIBRARY_ITEM_ON_CONFIRM_COGS_MODAL,
  LIBRARY_ITEM_FILL_FORM_DETAIL_ITEM,
  LIBRARY_ITEM_SUBMIT_FORM_UPDATE,
  LIBRARY_ITEM_SUBMIT_FORM_CREATE,
  LIBRARY_ITEM_DELETE_ITEM,
  LIBRARY_ITEM_ON_CLICK_CREATE_NEW_CATEGORY,
  LIBRARY_ITEM_ON_CLICK_CREATE_NEW_BRAND,
  LIBRARY_ITEM_CONFIRM_CREATE_NEW_CATEGORY,
  LIBRARY_ITEM_CANCEL_CREATE_NEW_CATEGORY,
  LIBRARY_ITEM_ON_SUCCESS_IMPORT,
  LIBRARY_ITEM_ON_REDIRECT_SALES_TYPE,
  LIBRARY_VALIDATION_NAME_MESSAGE,
  LIBRARY_ITEM_ITEM_LIST_EXPORT_ERROR,
  LIBRARY_ITEM_ITEM_LIST_EXPORT_FINISHED,
  LIBRARY_ITEM_CONFIRM_CREATE_NEW_BRAND,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_CONSTRUCT_DATA,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_SIZE_DATA,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_DATA,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_ALL_DATA,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_COLOR_DATA,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_DATA,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_ALL_DATA,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_ALL_DATA,
} from 'actions/library/item/constants';
import * as actItem from 'actions/library/item';
import * as apiProfile from 'api/profile';
import * as apiCategory from 'api/categories';
import * as apiOutlets from 'api/outlets';
import {
  initialize,
  arrayRemoveAll,
  arrayPush,
  reset,
  change,
} from 'redux-form';
import * as act from 'actions';
import * as actNotif from 'actions/notifications';
import * as apiItem from 'api/libraries/items';
import * as apiLoyalty from 'api/customers/loyalty';
import * as apiUploadImage from 'api/s3';
import * as actGetExportedFile from 'actions/get-exported-file';
import * as actOutletList from 'actions/outletPages/list';
import { setSelectedOutletIds } from 'actions/actionBar';
import { showPageLoadingSpinner } from 'actions/loadingSpinner';
import { subscriptionStatus } from 'actions/ingredients/ingredientSubscription';
import { getSubscriptionStatus } from 'api/feature/getSubscriptionStatus';
import { setFile, resetUploadImage } from 'actions/uploadImage';
import isFeatureEnabled from 'selectors/isFeatureEnabled';
import { getInventoryFeatureFlag } from 'api/inventory/inventoryFeatureFlag';

import _ from 'lodash';
import * as clevertapLibraryList from 'clevertap/library/list';
import { browserHistory } from 'react-router';
import { ITEM, ITEM_ALL } from 'utils/uploadS3Constants';
import {
  constructFormData,
  constructFormDataWithoutId,
} from '../../utils/s3Util';

const getCloneNotification = state =>
  state.outletPages.list.showCloneOutletNotification.notification;

const getFormItemVariants = state => state.form.item.values.item_variants;

const getFormModalItemVariants = state =>
  state.form.modal_item_variants.values.item_variants;

const getFormModalItemVariantsCustomCategoryVariant = state =>
  state.form.modal_item_variants.values.custom_category_variant;

const getItemCustomCategoryEcommerceFashionData = state =>
  state.library.item.customCategoriesEcommerceFashionData;

const getItemCustomCategoryEcommerceFashionAttribute = state =>
  state.library.item.customCategoriesEcommerceFashion;

const getInventoryFeatures = state =>
  state.inventoryFeatures.listInventoryFeature;

const getItemState = state => state.library.item;

let rewardItems = [];
let pointGainItems = [];
let rewardCategories = [];
let pointGainCategories = [];
let pointGainItemVariants = {};
let rewardItemVariants = {};
const featureNames = {
  loyalty: 'Loyalty',
  loyalty_pro: 'Loyalty Pro',
  ingredient_inventory: 'Ingredient Inventory',
};
const initItemList = {
  results: [],
  meta: {
    total_pages: 0,
    total_count: 0,
  },
};

/** **************************************
 * API Request saga
 *************************************** */

function* fillForm(item) {
  yield put(
    initialize('search', {
      categoryId: item.categoryId,
      outletId: item.outletId,
      typeInventoryId: item.typeInventoryId,
      search: item.search,
    })
  );
}

function* getCloneOutletNotification() {
  const notification = yield select(getCloneNotification);
  return notification;
}

export function* fillFormDetail(request) {
  const {
    payload: { formatFormDetail },
  } = request;
  yield put(
    initialize('item', {
      id: formatFormDetail.id,
      name: formatFormDetail.name,
      itemVariant: formatFormDetail.itemVariant,
      itemInventory: formatFormDetail.itemInventory,
      description: formatFormDetail.description,
      modifierIds: formatFormDetail.modifierIds,
      itemInventoryIds: formatFormDetail.itemInventoryIds,
    })
  );
}

export function* fetchSummary(params) {
  yield put(act.showProgressBar());
  try {
    const response = yield call(apiItem.getItems, params);
    const { data } = response;
    const totalPages = data.total_pages;
    const totalCount = data.total_count;
    const itemSummaryResponse = {
      total_pages: totalPages || 0,
      total_items: totalCount || 0,
    };
    return itemSummaryResponse;
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
    return false;
  } finally {
    yield put(act.hideProgressBar());
  }
}

function* setFilterItem(request) {
  yield put(actItem.setItems(initItemList));
  yield put(showPageLoadingSpinner(true));
  const {
    payload: { categoryId, outletId, typeInventoryId, keyword },
  } = request;
  yield put(
    actItem.setFilterState(categoryId, outletId, typeInventoryId, keyword)
  );
  yield put(act.showProgressBar());
  try {
    yield call(itemsRequest, {
      page: 0,
      outletId,
      categoryId,
      typeInventoryId,
      keyword,
    });
    yield put(
      actItem.itemSummaryRequest({ categoryId, typeInventoryId, keyword })
    );
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

function* fillSearch(profile) {
  let assignedOutletIds = [];
  if (profile.outlet_id.length > 1) {
    assignedOutletIds = [profile.outlet_id[0]];
  } else {
    assignedOutletIds = profile.outlet_id;
  }
  const data = { outletIds: assignedOutletIds };
  yield put(initialize('search', data));
}

export function* onChangeOutletIds(request) {
  yield put(actItem.closeRightColumn());
  yield put(actItem.setItems(initItemList));
  yield put(actItem.setItemSummary([]));
  yield put(showPageLoadingSpinner(true));
  yield put(resetUploadImage());
  const {
    payload: { outletIds },
  } = request;
  try {
    yield put(act.showProgressBar());
    yield call(apiOutlets.patchLogin, { id: outletIds });
    const resProfile = yield call(apiProfile.getProfile);
    yield put(setSelectedOutletIds(outletIds));
    yield put(change('search', 'outletIds', outletIds));
    yield put(actItem.setFilterState(0, resProfile.data.outlet_id[0], 0, ''));
    yield call(fillForm, {
      categoryId: 0,
      outletId: resProfile.data.outlet_id[0],
      typeInventoryId: 0,
      search: '',
    });
    yield call(fillSearch, resProfile.data);
    yield put(actItem.listCategoryWithUncategorizedRequest());
    yield call(itemsRequest, {
      page: 0,
      categoryId: 0,
      typeInventoryId: 0,
      keyword: '',
      outletId: resProfile.data.outlet_id[0],
      size: 50,
    });
    yield put(actItem.itemSummaryRequest({}));
    const modifierRes = yield call(apiItem.getModifiersList);
    yield put(actItem.setModifiers(modifierRes.data));
    yield put(actOutletList.checkCloningOutletOnProgress());
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

/**
 * Listen for page request of itemlibrary. This just works like wrapper
 */
export function* pageRequestFlow() {
  yield put(showPageLoadingSpinner(true));
  yield put(subscriptionStatus());
  yield put(actItem.setItems(initItemList));
  yield put(actItem.setItemSummary([]));
  yield put(actItem.setItemDetail(null));
  yield put(actItem.closeRightColumn());
  yield put(reset('item'));
  yield put(setFile(null));
  yield put(act.showProgressBar());
  const isEnabledEcommerceAttr = yield select(
    isFeatureEnabled,
    'ecommerce-attributes'
  );

  try {
    const response = yield call(apiOutlets.outlets);
    yield put(actItem.setOutlets(response.data));
    const resProfile = yield call(apiProfile.getProfile);
    yield put(actItem.setFilterState(0, resProfile.data.outlet_id[0], 0, ''));
    yield call(fillForm, {
      categoryId: 0,
      outletId: resProfile.data.outlet_id[0],
      typeInventoryId: 0,
      search: '',
    });
    yield call(fillSearch, resProfile.data);
    const params = {
      page: 0,
      categoryId: 0,
      typeInventoryId: 0,
      keyword: '',
      outletId: resProfile.data.outlet_id[0],
      size: 50,
    };
    let isRetail;
    const inventoryFeatures = yield select(getInventoryFeatures);
    isRetail = inventoryFeatures.includes('ECOMMERCE_ATTRIBUTES');
    if (!isRetail) {
      const getInventoryFeatures = yield call(getInventoryFeature);
      isRetail = getInventoryFeatures.includes('ECOMMERCE_ATTRIBUTES');
    }
    yield put(actItem.setIsRetailEcommerce(isRetail));
    if (isEnabledEcommerceAttr && isRetail) {
      const resp = yield call(ecommerceAttributeRequest);
      yield put(actItem.setEcommerceCategory(resp.data));
    }
    yield call(itemsRequest, params);
    const modifierRes = yield call(apiItem.getModifiersList);
    yield put(actItem.setModifiers(modifierRes.data));
    yield put(actItem.listCategoryWithUncategorizedRequest());
    yield put(actItem.itemSummaryRequest({}));
    clevertapLibraryList.libraryItemStart({
      outletIds: [resProfile.data.outlet_id[0]],
      category: 0,
      inventory: 0,
    });
    yield put(actOutletList.checkCloningOutletOnProgress());
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* getEcommerceAttribute() {
  yield put(act.showProgressBar());

  try {
    const response = yield call(apiItem.getEcommerceCategory);
    return response;
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
    return false;
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* getItems(params) {
  yield put(act.showProgressBar());

  try {
    const response = yield call(apiItem.getItems, params);
    const {
      data: { items },
    } = response;
    const totalPages = response.data.total_pages;
    const totalCount = response.data.total_count;
    const itemsResponse = {
      results: items,
      meta: {
        total_pages: totalPages || 0,
        total_count: totalCount || 0,
      },
    };
    return itemsResponse;
  } catch (error) {
    // If we get an error we send Redux the appropiate action and return
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
    return false;
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* getLoyalty(params) {
  yield put(act.showProgressBar());

  try {
    const response = yield call(apiLoyalty.getLoyalty, params);
    return response.data;
  } catch (error) {
    // If we get an error we send Redux the appropiate action and return
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
    return false;
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* ecommerceAttributeRequest() {
  try {
    const ecommerceAttributeResponse = yield call(getEcommerceAttribute);
    return ecommerceAttributeResponse;
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
  yield put(showPageLoadingSpinner(false));
}

export function* itemsRequest(request) {
  let categoryId;
  let outletId;
  let typeInventoryId;
  let keyword;
  let page;
  let size;
  let previousItems;
  let items;
  if (request.payload) {
    const requestPayload = request.payload.query;
    const { filterState } = requestPayload;
    previousItems = request.payload.previousItems;
    categoryId = filterState.categoryId;
    outletId = filterState.outletId;
    typeInventoryId = filterState.typeInventoryId;
    keyword = filterState.keyword;
    page = requestPayload.page;
    size = 50;
  } else {
    categoryId = request.categoryId;
    outletId = request.outletId;
    typeInventoryId = request.typeInventoryId;
    keyword = request.keyword;
    page = request.page;
    size = request.size;
  }
  const query = {
    page,
    category_id: !parseInt(categoryId) ? '' : categoryId,
    outlet_id: !parseInt(outletId) ? '' : outletId,
    inventory: !parseInt(typeInventoryId)
      ? 'all'
      : typeInventoryId === '1'
      ? 'low'
      : 'out',
    keyword: !keyword ? '' : keyword,
    is_mobile: request.is_mobile,
    size,
  };

  yield put(act.showProgressBar());

  try {
    const itemsResponse = yield call(getItems, query);
    if (previousItems) {
      items = previousItems;
      if (itemsResponse.results) {
        items.results = previousItems.results.concat(itemsResponse.results);
      }
    } else {
      items = itemsResponse;
    }

    const loyaltyResponse = yield call(getLoyalty, null);
    const response = yield call(getSubscriptionStatus, {
      feature_names: Object.values(featureNames),
    });
    const subscriptionArray = response.data;
    const subscriptionDetail = _.assign(
      subscriptionDetail,
      _.mapKeys(subscriptionArray, 'name')
    );

    // Clearing the previous reward items, categories and item variants .....

    rewardItems = [];
    pointGainItems = [];
    rewardCategories = [];
    pointGainCategories = [];
    pointGainItemVariants = {};
    rewardItemVariants = {};

    loyaltyResponse.forEach(program => {
      if (
        program.status === 'ACTIVE' &&
        subscriptionDetail['Loyalty Pro'].is_active
      ) {
        program.rewards.forEach(reward => {
          if (reward.reward_items) {
            reward.reward_items.forEach(rewardItem => {
              if (rewardItem.type === 'CATEGORY') {
                rewardCategories.push(rewardItem.category_name);
              } else {
                rewardItems.push(rewardItem.item_name);
                rewardItemVariants[
                  rewardItem.item_name
                ] = rewardItem.item_variant_names
                  ? rewardItem.item_variant_names
                  : [];
              }
            });
          }
        });
        program.earning_rules.forEach(earningRule => {
          if (earningRule.type === 'ITEM') {
            earningRule.item_rules.forEach(rule => {
              if (rule.type === 'ITEM' || rule.type === 'ITEM_VARIANT') {
                pointGainItems.push(rule.item_name);
                pointGainItemVariants[rule.item_name] = rule.item_variant_names
                  ? rule.item_variant_names
                  : [];
              } else {
                pointGainCategories.push(rule.category_name);
              }
            });
          }
        });
      }
    });

    yield put(actItem.setRewardItemList(rewardItems));
    yield put(actItem.setRewardCategoryList(rewardCategories));
    yield put(actItem.setRewardItemVariantList(rewardItemVariants));

    yield put(actItem.setPointGainItemList(pointGainItems));
    yield put(actItem.setPointGainCategoryList(pointGainCategories));
    yield put(actItem.setPointGainItemVariantList(pointGainItemVariants));

    if (items.results !== undefined) {
      items.results.forEach(item => {
        if (item.active_modifiers === undefined) {
          item.active_modifiers = [];
        }
        if (item.is_recipe === undefined) {
          item.is_recipe = false;
        }
        // Handle condition that attributes are removed by protobuf
        item.item_variants.forEach(itemVariant => {
          if (
            itemVariant.price === undefined &&
            (itemVariant.is_variable_price === undefined ||
              itemVariant.is_variable_price === false)
          ) {
            itemVariant.price = 0;
          }
          if (itemVariant.in_stock === undefined) {
            itemVariant.in_stock = 0;
          }
          if (itemVariant.stock_alert === undefined) {
            itemVariant.stock_alert = 0;
          }
          if (itemVariant.position === undefined) {
            itemVariant.position = 0;
          }
          if (itemVariant.add_inventory === undefined) {
            itemVariant.add_inventory = 0;
          }
          if (itemVariant.track_stock === undefined) {
            itemVariant.track_stock = false;
          }
          if (itemVariant.alert === undefined) {
            itemVariant.alert = false;
          }
          if (itemVariant.has_cogs === undefined) {
            itemVariant.has_cogs = false;
          } else if (itemVariant.cogs === undefined) {
            itemVariant.cogs = 0;
          }
          if (itemVariant.track_cogs === undefined) {
            itemVariant.track_cogs = false;
          }
          if (itemVariant.is_saved === undefined) {
            itemVariant.is_saved = false;
          }
          if (itemVariant.is_recipe === undefined) {
            itemVariant.is_recipe = false;
          }
          if (itemVariant.sales_type_items !== undefined) {
            itemVariant.sales_type_items.forEach(salesTypeItem => {
              if (
                salesTypeItem.sales_type_price === undefined &&
                (salesTypeItem.is_variable_price === undefined ||
                  salesTypeItem.is_variable_price === false)
              ) {
                salesTypeItem.sales_type_price = 0;
              }
            });
          } else {
            itemVariant.sales_type_items = [];
          }
        });
        item.is_reward_item = rewardItems.indexOf(item.name) > -1;
        item.is_reward_category_item =
          rewardCategories.indexOf(item.category.name) > -1;
        item.item_variants.forEach(itemVariant => {
          itemVariant.is_reward_item_variant = rewardItemVariants[item.name]
            ? rewardItemVariants[item.name].indexOf(itemVariant.name) > -1
            : false;
          if (itemVariant.stock_alert && !itemVariant.in_stock) {
            itemVariant.in_stock = 0;
          }
        });
        item.is_point_gain_item = pointGainItems.indexOf(item.name) > -1;
        item.is_point_gain_category_item =
          pointGainCategories.indexOf(item.category.name) > -1;
        item.item_variants.forEach(itemVariant => {
          itemVariant.is_point_gain_item_variant = pointGainItemVariants[
            item.name
          ]
            ? pointGainItemVariants[item.name].indexOf(itemVariant.name) > -1
            : false;
        });
      });
      yield put(actItem.setItems(items)); // todo refactor
    } else {
      items.results = [];
      yield put(actItem.setItems(items)); // todo refactor
    }
    if (page < 1) {
      const summary = {
        total_items: items.meta.total_count,
        total_pages: items.meta.total_pages,
      };
      yield put(actItem.setItemSummary(summary));
      yield put(actItem.setTotalPage(summary.total_pages));
    }
    yield put(actItem.setCurrentPage(page));
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
  yield put(showPageLoadingSpinner(false));
}

/**
 * Listen for listen category request
 * It will fetch category data from the server and set the category state with action
 */
export function* getCategoriesWithUncategorizedFlow() {
  while (true) {
    yield take(LIBRARY_ITEM_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST);
    const categories = yield call(getCategoriesWithUncategorized);
    if (categories) {
      yield put(actItem.setCategories(categories));
    }
  }
}

export function* getExportItem(request) {
  yield put(act.showLoadingSpinner(true));
  try {
    const {
      payload: {
        prefix,
        email,
        outlets,
        outlet,
        params: { category_id, inventory, keyword, outletId },
      },
    } = request;
    const selectedOutlet = outlets.filter(ot => {
      return ot.id === outlet;
    })[0];
    const fileName = `${prefix}${selectedOutlet.name} - ${email}`;
    const response = yield call(apiItem.getExportItem, {
      fileName,
      category_id,
      inventory,
      keyword,
      outlet_id: outletId,
    });
    const responseData = {
      asyncJobCreated: response.data.async_job_created,
      asyncJobId: response.data.async_job_id,
      pusherEvent: response.data.pusher_event,
      pusherChannel: response.data.pusher_channel,
    };
    yield put(actItem.itemExportStart(responseData));
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
    yield put(act.showLoadingSpinner(false));
  }
}

export function* itemExportFinished() {
  yield put(act.showLoadingSpinner(false));
}

export function* itemExportError(error) {
  yield put(actNotif.error(error.message, yield getCloneOutletNotification()));
  yield put(act.showLoadingSpinner(false));
}

export function* downloadItemsTemplate(request) {
  const {
    payload: { prefix },
  } = request;
  yield put(act.showLoadingSpinner(true));
  try {
    const response = yield call(apiItem.getItemTemplate);
    const responseData = response.data;
    if (responseData.message === 'ok') {
      yield put(actGetExportedFile.getExportedWithoutOutlet(prefix));
    } else {
      yield put(
        actNotif.error(responseData.message, yield getCloneOutletNotification())
      );
    }
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.showLoadingSpinner(false));
  }
}

function* closeRightColumn() {
  yield put(actItem.closeRightColumn());
}

export function* clickCancel() {
  yield put(actItem.setItemDetail(null));
  yield put(reset('item'));
  yield call(closeRightColumn);
  yield put(setFile(null));
}

export function* onClickBtnItemVariant(request) {
  const {
    payload: { itemForm },
  } = request;
  yield put(actItem.showItemVariantModal());
  yield put(initialize('modal_item_variants', itemForm));
  yield put(actItem.setPreviousItemForm(itemForm));
}

export function* onCancelItemVariantModal() {
  yield put(initialize('modal_item_variants', {}));
  yield put(actItem.hideItemVariantModal());
}

export function* onCancelSalesTypeModal() {
  yield put(initialize('modal_item_variants', {}));
  yield put(actItem.hideSalesTypeModal());
}

export function* onConfirmItemVariantModal(request) {
  const { value } = request.payload;
  yield put(arrayRemoveAll('item', 'item_variants'));
  for (let idx = 0; idx < value.item_variants.length; idx++) {
    yield put(arrayPush('item', 'item_variants', value.item_variants[idx]));
  }
  yield put(initialize('modal_item_variants', {}));
  yield put(actItem.hideItemVariantModal());
}

export function* onConfirmSalesTypeModal(request) {
  const { value } = request.payload;
  yield put(arrayRemoveAll('item', 'item_variants'));
  yield put(arrayRemoveAll('item', 'sales_type'));

  const deselectedSalesType = value.sales_type
    .filter(salesType => !salesType.selected)
    .map(salesType => salesType.id);
  value.item_variants.forEach(itemVariant => {
    itemVariant.sales_type_items = itemVariant.sales_type_items.filter(
      salesTypeItem =>
        deselectedSalesType.indexOf(salesTypeItem.sales_type_id) === -1
    );
  });

  value.item_variants.forEach(itemVariant => {
    const existingSalesTypeIds = itemVariant.sales_type_items.map(
      salesTypeItem => salesTypeItem.sales_type_id
    );
    const newSalesType = value.sales_type.filter(
      salesType =>
        existingSalesTypeIds.indexOf(salesType.id) === -1 && salesType.selected
    );
    newSalesType.forEach(salesType => {
      itemVariant.sales_type_items.push({
        sales_type_id: salesType.id,
        sales_type_name: salesType.name,
      });
    });
  });

  for (let idx = 0; idx < value.sales_type.length; idx++) {
    yield put(arrayPush('item', 'sales_type', value.sales_type[idx]));
  }
  for (let idx = 0; idx < value.item_variants.length; idx++) {
    yield put(arrayPush('item', 'item_variants', value.item_variants[idx]));
  }
  yield put(reset('modal_sales_type'));
  yield put(actItem.hideSalesTypeModal());
}

export function* onClickBtnSalesType(request) {
  const {
    payload: { itemForm, search, user, outlets },
  } = request;
  yield put(actItem.showSalesTypeModal());
  yield put(initialize('modal_sales_type', itemForm));
  yield put(actItem.setPreviousItemForm(itemForm));
  clevertapLibraryList.libraryManageSalesType(itemForm, user, search, outlets);
}

export function* onClickBtnItemTracking(request) {
  const {
    payload: { itemForm, isTrack },
  } = request;
  yield put(actItem.showItemInventoryAleryModal());
  yield put(actItem.setPreviousItemForm(itemForm));
  let thereIsNew = false;
  const itemVariantsWithTracking = itemForm.item_variants.map(iv => {
    if (iv.is_new || !isTrack) {
      thereIsNew = true;
      return {
        ...iv,
        track_stock: true,
        stock_alert: iv.stock_alert ? iv.stock_alert : '0',
        alert: true,
        in_stock: iv.in_stock ? iv.in_stock : '0',
        is_new: false,
      };
    }
    return { ...iv };
  });
  // HACKY CODE
  // hack ini untuk mengakai hack yang dilakukan pada file yang sebelumnya pada saat solve FD-1471,
  // inti hack ini mencegah dirtyform jika tidak ada perubahan pada form item ketika confirm nanti, dan perlunya dirty pada saat ada iv baru
  // is_new akan true jika item variant baru terbentuk, dan akan false ketika ia di track
  if (thereIsNew) {
    yield put(
      initialize('modal_item_variants', { ...itemForm, item_variants: [] })
    );
    for (let idx = 0; idx < itemVariantsWithTracking.length; idx++) {
      yield put(
        arrayPush(
          'modal_item_variants',
          'item_variants',
          itemVariantsWithTracking[idx]
        )
      );
    }
  } else {
    const newItem = { ...itemForm, item_variants: itemVariantsWithTracking };
    yield put(initialize('modal_item_variants', newItem));
  }
}

export function* onClickBtnCOGSTracking(request) {
  const {
    payload: { itemForm, isTrack },
  } = request;
  yield put(actItem.showCOGSModal(isTrack));
  yield put(actItem.setPreviousItemForm(itemForm));
  if (!isTrack) {
    const itemVariantsWithTracking = itemForm.item_variants.map(iv => {
      if (!itemForm.id && iv.track_stock && iv.track_cogs === undefined) {
        return {
          ...iv,
          track_cogs: true,
        };
      }
      return {
        ...iv,
      };
    });
    const newItem = { ...itemForm, item_variants: itemVariantsWithTracking };
    yield put(initialize('modal_item_variants', newItem));
  } else {
    yield put(initialize('modal_item_variants', itemForm));
  }
}

export function* onCancelItemInventoryAlertModal() {
  yield put(initialize('modal_item_variants', {}));
  yield put(actItem.hideItemInventoryAlertModal());
}

export function* onCancelCOGSModal() {
  yield put(initialize('modal_item_variants', {}));
  yield put(actItem.hideCOGSModal());
}

export function* submitFormCreate(request) {
  const {
    payload: {
      values,
      items,
      allOutlet,
      search,
      salesType,
      user,
      outlets,
      inStock,
      image,
    },
  } = request;
  const isEnabledEcommerceAttr = yield select(
    isFeatureEnabled,
    'ecommerce-attributes'
  );
  const inventoryFeatures = yield select(getInventoryFeatures);
  const { ecommerceCategory } = yield select(getItemState);
  const isRetail = inventoryFeatures.includes('ECOMMERCE_ATTRIBUTES');
  try {
    yield put(act.showProgressBar());
    yield put(actItem.setIsSubmittingForm(true));
    let trackedItems = [];
    const newImages = [];
    const { item } = values;
    const { images } = item;
    values.item.item_variants.forEach((iv, index) => {
      iv.position = index;
      if (iv.track_stock) {
        const ivTemp = Object.create(iv);
        ivTemp.name = ivTemp.name.length > 0 ? ivTemp.name : values.item.name;
        ivTemp.in_stock = inStock[index];
        ivTemp.stock_alert = parseInt(ivTemp.stock_alert, 10);
        trackedItems = [...trackedItems, ivTemp];
      }
    });
    let postItemRes;
    let updatedItem;
    if (allOutlet) {
      // TODO handle new save to all flow
      delete values.item.images;
      if (isEnabledEcommerceAttr && isRetail) {
        if (images && images.length > 0) {
          const listImages = images.map(image => ({
            data: image.raw_image_url,
            file_name: image.file_name,
          }));
          for (const i in listImages) {
            const image = yield call(
              apiItem.postItemImage,
              search.outletIds[0],
              listImages[i]
            );
            newImages.push({
              raw_image_id: image.data.id,
              url: image.data.url,
            });
          }
          values.item.images = newImages;
        }
        if (!item.is_ecommerce) {
          delete values.item.condition;
          delete values.item.age;
          delete values.item.gender;
          delete values.item.weight;
          delete values.item.dimension;
          delete values.item.width;
          delete values.item.length;
          delete values.item.height;
          values.item.brand_id = null;
        } else {
          values.item.weight = (
            values.item.weight.value * values.item.weight.valueUniversal
          ).toFixed(2);

          values.item.length = (
            values.item.dimension.length * values.item.dimension.valueUniversal
          ).toFixed(2);

          values.item.width = (
            values.item.dimension.width * values.item.dimension.valueUniversal
          ).toFixed(2);

          values.item.height = (
            values.item.dimension.height * values.item.dimension.valueUniversal
          ).toFixed(2);

          delete values.item.age;
          delete values.item.gender;
          delete values.item.dimension;
        }
      }
      // Call api validate
      const postValidateItemRes = yield call(
        apiItem.validateSaveToAllOutlet,
        values
      );
      const validationResult = postValidateItemRes.data;
      if (
        validationResult.name_unique_error.length > 0 &&
        validationResult.sales_type_not_exist_error.length > 0
      ) {
        yield put(actItem.setValidationModal(true));
        yield put(
          actItem.setValidationModalMessage(
            LIBRARY_VALIDATION_NAME_MESSAGE.BOTH
          )
        );
        return;
      }
      if (validationResult.name_unique_error.length > 0) {
        yield put(actItem.setValidationModal(true));
        yield put(
          actItem.setValidationModalMessage(
            LIBRARY_VALIDATION_NAME_MESSAGE.NAME_NOT_UNIQUE
          )
        );
        return;
      }
      if (validationResult.sales_type_not_exist_error.length > 0) {
        yield put(actItem.setValidationModal(true));
        yield put(
          actItem.setValidationModalMessage(
            LIBRARY_VALIDATION_NAME_MESSAGE.SALES_TYPE_NOT_EXIST
          )
        );
        return;
      }
      let imageUrl = '';
      if (image) {
        const formData = constructFormDataWithoutId(image, ITEM_ALL);
        const resUpload = yield call(apiUploadImage.postNewImage, formData, {});
        imageUrl = resUpload.data.download_image_url;
      }
      values.item.remote_image_url = imageUrl;
      values.item.image.url = imageUrl;

      // if no error and dont have validation error in validatiion response then call api save_to_all_outlet
      postItemRes = yield call(apiItem.postCreateAllOutletItemV3, values);
      const createdItem = postItemRes.data.item;
      const updatedItemRes = isEnabledEcommerceAttr
        ? yield call(apiItem.getItemByIdV2, createdItem.id)
        : yield call(apiItem.getItemById, createdItem.id);
      updatedItem = updatedItemRes.data;
      updatedItem.sales_type = setSalesType(updatedItem, salesType);
      items.results.unshift(updatedItem);
      items.meta.total_count++;

      // after showing warning error, if user klik yes to save to current outlet, just save it
      // or user klik cancel then cancel the save operation
    } else {
      if (isEnabledEcommerceAttr && isRetail) {
        if (images && images.length > 0) {
          const listImages = images.map(image => ({
            data: image.raw_image_url,
            file_name: image.file_name,
          }));
          for (const i in listImages) {
            const image = yield call(
              apiItem.postItemImage,
              search.outletIds[0],
              listImages[i]
            );
            newImages.push({
              raw_image_id: image.data.id,
              url: image.data.url,
            });
          }
          values.item.images = newImages;
        }
        if (!item.is_ecommerce) {
          delete values.item.condition;
          delete values.item.age;
          delete values.item.gender;
          delete values.item.weight;
          delete values.item.dimension;
          delete values.item.width;
          delete values.item.length;
          delete values.item.height;
          values.item.brand_id = null;
        } else {
          values.item.weight = (
            values.item.weight.value * values.item.weight.valueUniversal
          ).toFixed(2);

          values.item.length = (
            values.item.dimension.length * values.item.dimension.valueUniversal
          ).toFixed(2);

          values.item.width = (
            values.item.dimension.width * values.item.dimension.valueUniversal
          ).toFixed(2);

          values.item.height = (
            values.item.dimension.height * values.item.dimension.valueUniversal
          ).toFixed(2);

          delete values.item.age;
          delete values.item.gender;
          delete values.item.dimension;
        }
      }
      // prevent downloading file when creating item
      values.item.remote_image_url = '';
      postItemRes = yield call(apiItem.postItem, values);

      // upload image after item created
      if (image) {
        const formData = constructFormData(image, ITEM, postItemRes.data.id);
        yield call(apiUploadImage.postNewImage, formData, {
          OUTLET_ID: postItemRes.data.outlet_id,
        });
        // remove state upload after uploading
        yield put(resetUploadImage());
      }

      const updatedItemRes = isEnabledEcommerceAttr
        ? yield call(apiItem.getItemByIdV2, postItemRes.data.id)
        : yield call(apiItem.getItemById, postItemRes.data.id);
      updatedItem = updatedItemRes.data;
      updatedItem.sales_type = setSalesType(updatedItem, salesType);
      items.results.unshift(updatedItem);
      items.meta.total_count++;
    }
    for (let i = 0; i < updatedItem.item_variants.length; i++) {
      const jLength = updatedItem.item_variants[i]
        .item_variant_ecommerce_attributes
        ? updatedItem.item_variants[i].item_variant_ecommerce_attributes.length
        : 0;
      for (let j = 0; j < jLength; j++) {
        const {
          ecommerce_attribute_name: attributeName,
          value,
        } = updatedItem.item_variants[i].item_variant_ecommerce_attributes[j];

        let isEcommerceVariant = false;

        if (
          attributeName === 'color' ||
          attributeName === 'size' ||
          attributeName === 'material'
        ) {
          if (!isEcommerceVariant) {
            updatedItem.item_variants[i].is_ecommerce = true;
            put(change('modal_item_variants', 'custom_category_variant', true));
          }
          isEcommerceVariant = true;
          const actionType = `setCustomCategoryFashion${attributeName
            .charAt(0)
            .toUpperCase() + attributeName.slice(1)}DataNoSaga`;
          put(actItem[actionType](value.trim()));
        }
      }
    }

    if (
      updatedItem.active_modifiers === undefined ||
      updatedItem.active_modifiers === null
    ) {
      updatedItem.active_modifiers = [];
    }
    if (updatedItem.is_recipe === undefined) {
      updatedItem.is_recipe = false;
    }
    updatedItem.item_variants.forEach(itemVariant => {
      itemVariant.is_editable = !itemVariant.is_saved;
      itemVariant.saved_cogs = !(
        !itemVariant.has_cogs && !itemVariant.track_cogs
      );
      if (
        itemVariant.price === undefined &&
        (itemVariant.is_variable_price === undefined ||
          itemVariant.is_variable_price === false)
      ) {
        itemVariant.price = 0;
      }
      if (itemVariant.in_stock === undefined) {
        itemVariant.in_stock = 0;
      }
      if (itemVariant.stock_alert === undefined) {
        itemVariant.stock_alert = 0;
      }
      if (itemVariant.position === undefined) {
        itemVariant.position = 0;
      }
      if (itemVariant.add_inventory === undefined) {
        itemVariant.add_inventory = 0;
      }
      if (itemVariant.track_stock === undefined) {
        itemVariant.track_stock = false;
      }
      if (itemVariant.alert === undefined) {
        itemVariant.alert = false;
      }
      if (itemVariant.has_cogs === undefined) {
        itemVariant.has_cogs = false;
      } else if (itemVariant.cogs === undefined) {
        itemVariant.cogs = 0;
      }
      if (itemVariant.track_cogs === undefined) {
        itemVariant.track_cogs = false;
      }
      if (itemVariant.is_saved === undefined) {
        itemVariant.is_saved = false;
      }
      if (itemVariant.is_recipe === undefined) {
        itemVariant.is_recipe = false;
      }
      if (
        itemVariant.sales_type_items !== undefined &&
        itemVariant.sales_type_items !== null
      ) {
        itemVariant.sales_type_items.forEach(salesTypeItem => {
          if (
            salesTypeItem.sales_type_price === undefined &&
            (salesTypeItem.is_variable_price === undefined ||
              salesTypeItem.is_variable_price === false)
          ) {
            salesTypeItem.sales_type_price = 0;
          }
        });
      } else {
        itemVariant.sales_type_items = [];
      }
    });
    if (isEnabledEcommerceAttr && isRetail) {
      updatedItem.item_variants[0].item_variant_ecommerce_attributes &&
        updatedItem.item_variants[0].item_variant_ecommerce_attributes.forEach(
          attr => {
            if (
              attr.ecommerce_attribute_name === 'age' ||
              attr.ecommerce_attribute_name === 'gender'
            ) {
              updatedItem[attr.ecommerce_attribute_name] = {
                id: attr.id,
                value: attr.value,
              };
            }
          }
        );
      updatedItem.weight = {
        value: updatedItem.weight,
        unit: 'Gram (gr)',
        valueUniversal: 1,
      };
      updatedItem.dimension = {
        length: updatedItem.length,
        width: updatedItem.width,
        height: updatedItem.height,
        unit: 'Centimeter (cm)',
        valueUniversal: 1,
      };
      if (!updatedItem.condition) updatedItem.condition = 'New';
      if (updatedItem.ecommerce_category_id === 1) {
        if (!updatedItem.age) {
          ecommerceCategory.ecommerce_attributes.map(attr => {
            if (attr.name === 'age') {
              updatedItem[attr.name] = {
                id: attr.id,
                value: 'All Ages',
              };
            }
          });
        }
        if (!updatedItem.gender) {
          ecommerceCategory.ecommerce_attributes.map(attr => {
            if (attr.name === 'gender') {
              updatedItem[attr.name] = {
                id: attr.id,
                value: 'Unisex',
              };
            }
          });
        }
      }
    }
    yield put(initialize('item', updatedItem));
    clevertapLibraryList.libraryItemCreate(
      updatedItem,
      allOutlet,
      user,
      search,
      outlets
    );
    if (trackedItems.length > 0) {
      clevertapLibraryList.libraryItemStartTrackingStockAlert(
        trackedItems,
        values.item.name
      );
    }
    const query = {
      page: 0,
      category_id: !parseInt(search.categoryId) ? '' : search.categoryId,
      inventory: !parseInt(search.typeInventoryId)
        ? 'all'
        : search.typeInventoryId === '1'
        ? 'low'
        : 'out',
      keyword: !search.search ? '' : search.search,
      outlet_id: search.outletIds[0],
    };
    const summary = yield call(fetchSummary, query); // todo refactor
    yield put(actItem.setItemSummary(summary));

    yield put(actItem.setItems(items));
    yield put(actItem.setItemDetail(updatedItem));
    if (allOutlet) {
      if (postItemRes.data.is_async_perform) {
        yield put(actItem.showSaveToAllOutletsModal());
      } else {
        yield put(
          actNotif.success(
            'Item was successfully created.',
            yield getCloneOutletNotification()
          )
        );
      }
    } else {
      yield put(
        actNotif.success(
          'Item was successfully created.',
          yield getCloneOutletNotification()
        )
      );
    }
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(actItem.setIsSubmittingForm(false));
    yield put(act.hideProgressBar());
  }
}

export function* submitFormUpdate(request) {
  const {
    payload: {
      itemId,
      values,
      allOutlet,
      items,
      salesType,
      itemDetail,
      user,
      outlets,
      search,
      inStock,
      image,
    },
  } = request;
  const isEnabledEcommerceAttr = yield select(
    isFeatureEnabled,
    'ecommerce-attributes'
  );
  const inventoryFeatures = yield select(getInventoryFeatures);
  const isRetail = inventoryFeatures.includes('ECOMMERCE_ATTRIBUTES');
  try {
    yield put(act.showProgressBar());
    yield put(actItem.setIsSubmittingForm(true));
    const isImageUpdated =
      (itemDetail.image.url === null && image !== null) ||
      (itemDetail.image.url !== null && image !== null) ||
      (itemDetail.image.url !== null && image === null);

    if (image || !values.item.image.url) {
      const formData = constructFormData(image, ITEM, itemId);
      const res = yield call(apiUploadImage.postNewImage, formData, {
        OUTLET_ID: values.item.outlet_id,
      });
      if (res.data) {
        const imageUrl = res.data.download_image_url;
        values.item.image.url = imageUrl;
        values.item.image.is_new_image = isImageUpdated;
      }
    }

    const {
      item: { images },
    } = values;
    if (isEnabledEcommerceAttr && isRetail) {
      for (const i in images) {
        // only new images
        if (images[i].id === undefined) {
          images[i].data = images[i].raw_image_url;
          delete images[i].raw_image_url;
          const newImage = yield call(
            apiItem.postItemImage,
            search.outletIds[0],
            images[i]
          );
          values.item.images[i] = {
            raw_image_id: newImage.data.id,
            url: newImage.data.url,
          };
        }
      }
      if (values.item.is_ecommerce) {
        values.item.weight = (
          values.item.weight.value * values.item.weight.valueUniversal
        ).toFixed(2);

        values.item.length = (
          values.item.dimension.length * values.item.dimension.valueUniversal
        ).toFixed(2);

        values.item.width = (
          values.item.dimension.width * values.item.dimension.valueUniversal
        ).toFixed(2);

        values.item.height = (
          values.item.dimension.height * values.item.dimension.valueUniversal
        ).toFixed(2);
      } else {
        delete values.item.weight;
        delete values.item.conditon;
      }
      delete values.item.age;
      delete values.item.gender;
      delete values.item.dimension;
    }

    let trackedItems = [];
    let untrackedItems = [];
    let responseUpdate;
    values.item.item_variants.map((iv, index) => {
      if (!iv.track_cogs) {
        iv.cogs = null;
      }
      if (iv.track_stock) {
        const ivTemp = Object.create(iv);
        ivTemp.name =
          Boolean(ivTemp.name) && ivTemp.name.length > 0
            ? ivTemp.name
            : values.item.name;
        ivTemp.in_stock = inStock[index];
        trackedItems = [...trackedItems, ivTemp];
      } else if (
        values.item.item_variants.length === itemDetail.item_variants.length &&
        !iv.track_stock &&
        itemDetail.item_variants[index].track_stock
      ) {
        const ivTemp = Object.create(iv);
        ivTemp.name =
          Boolean(ivTemp.name) && ivTemp.name.length > 0
            ? ivTemp.name
            : values.item.name;
        ivTemp.in_stock = inStock[index];
        untrackedItems = [...untrackedItems, ivTemp];
      }
      iv.position = index;
      if (iv.sales_type_items !== undefined && iv.sales_type_items !== null) {
        iv.sales_type_items.map(sti => {
          if (sti !== undefined && sti.sales_type_price !== undefined) {
            sti.is_variable_price = false;
          } else {
            sti.is_variable_price = true;
          }
        });
      }
    });
    if (allOutlet) {
      responseUpdate = yield call(apiItem.putItemAllOutlet, itemId, values);
    } else {
      responseUpdate = yield call(apiItem.putItemById, itemId, values);
    }
    const updatedItemRes = isEnabledEcommerceAttr
      ? yield call(apiItem.getItemByIdV2, itemId)
      : yield call(apiItem.getItemById, itemId);
    const updatedItem = updatedItemRes.data;
    // setting reward details
    updatedItem.is_reward_item = rewardItems.indexOf(updatedItem.name) > -1;
    updatedItem.is_reward_category_item =
      rewardCategories.indexOf(updatedItem.category.name) > -1;
    updatedItem.item_variants.forEach(itemVariant => {
      itemVariant.is_reward_item_variant = rewardItemVariants[updatedItem.name]
        ? rewardItemVariants[updatedItem.name].indexOf(itemVariant.name) > -1
        : false;
    });
    // setting point gain details
    updatedItem.is_point_gain_item =
      pointGainItems.indexOf(updatedItem.name) > -1;
    updatedItem.is_point_gain_category_item =
      pointGainCategories.indexOf(updatedItem.category.name) > -1;
    if (
      updatedItem.active_modifiers === undefined ||
      updatedItem.active_modifiers === null
    ) {
      updatedItem.active_modifiers = [];
    }
    if (updatedItem.is_recipe === undefined) {
      updatedItem.is_recipe = false;
    }
    updatedItem.item_variants.forEach(itemVariant => {
      itemVariant.is_point_gain_item_variant = pointGainItemVariants[
        updatedItem.name
      ]
        ? pointGainItemVariants[updatedItem.name].indexOf(itemVariant.name) > -1
        : false;
      if (
        itemVariant.price === undefined &&
        (itemVariant.is_variable_price === undefined ||
          itemVariant.is_variable_price === false)
      ) {
        itemVariant.price = 0;
      }
      if (itemVariant.in_stock === undefined) {
        itemVariant.in_stock = 0;
      }
      if (itemVariant.stock_alert === undefined) {
        itemVariant.stock_alert = 0;
      }
      if (itemVariant.position === undefined) {
        itemVariant.position = 0;
      }
      if (itemVariant.add_inventory === undefined) {
        itemVariant.add_inventory = 0;
      }
      if (itemVariant.track_stock === undefined) {
        itemVariant.track_stock = false;
      }
      if (itemVariant.alert === undefined) {
        itemVariant.alert = false;
      }
      if (itemVariant.has_cogs === undefined) {
        itemVariant.has_cogs = false;
      } else if (itemVariant.cogs === undefined) {
        itemVariant.cogs = 0;
      }
      if (itemVariant.track_cogs === undefined) {
        itemVariant.track_cogs = false;
      }
      if (itemVariant.is_saved === undefined) {
        itemVariant.is_saved = false;
      }
      if (itemVariant.is_recipe === undefined) {
        itemVariant.is_recipe = false;
      }
      if (
        itemVariant.sales_type_items !== undefined &&
        itemVariant.sales_type_items !== null
      ) {
        itemVariant.sales_type_items.forEach(salesTypeItem => {
          if (
            salesTypeItem.sales_type_price === undefined &&
            (salesTypeItem.is_variable_price === undefined ||
              salesTypeItem.is_variable_price === false)
          ) {
            salesTypeItem.sales_type_price = 0;
          }
        });
      } else {
        itemVariant.sales_type_items = [];
      }
    });
    updatedItem.sales_type = setSalesType(updatedItem, salesType);

    items.results.forEach((item, index) => {
      if (updatedItem.id === item.id) {
        items[index] = { ...updatedItem };
      }
    });

    // set ecommerce attributes
    if (isEnabledEcommerceAttr && isRetail) {
      updatedItem.item_variants[0].item_variant_ecommerce_attributes &&
        updatedItem.item_variants[0].item_variant_ecommerce_attributes.forEach(
          attr => {
            if (
              attr.ecommerce_attribute_name === 'age' ||
              attr.ecommerce_attribute_name === 'gender'
            ) {
              updatedItem[attr.ecommerce_attribute_name] = {
                id: attr.id,
                value: attr.value,
              };
            }
          }
        );
      updatedItem.weight = {
        value: updatedItem.weight,
        unit: 'Gram (gr)',
        valueUniversal: 1,
      };
      updatedItem.dimension = {
        length: updatedItem.length,
        width: updatedItem.width,
        height: updatedItem.height,
        unit: 'Centimeter (cm)',
        valueUniversal: 1,
      };
    }

    for (let i = 0; i < updatedItem.item_variants.length; i++) {
      const jLength = updatedItem.item_variants[i]
        .item_variant_ecommerce_attributes
        ? updatedItem.item_variants[i].item_variant_ecommerce_attributes.length
        : 0;
      for (let j = 0; j < jLength; j++) {
        const {
          ecommerce_attribute_name: attributeName,
          value,
        } = updatedItem.item_variants[i].item_variant_ecommerce_attributes[j];

        let isEcommerceVariant = false;

        if (
          attributeName === 'color' ||
          attributeName === 'size' ||
          attributeName === 'material'
        ) {
          if (!isEcommerceVariant) {
            updatedItem.item_variants[i].is_generated = true;
            put(change('modal_item_variants', 'custom_category_variant', true));
          }
          isEcommerceVariant = true;
          const actionType = `setCustomCategoryFashion${attributeName
            .charAt(0)
            .toUpperCase() + attributeName.slice(1)}DataNoSaga`;
          put(actItem[actionType](value.trim()));
        }
      }
    }

    yield put(initialize('item', updatedItem));
    if (trackedItems.length > 0) {
      clevertapLibraryList.libraryItemStartTrackingStockAlert(
        trackedItems,
        values.item.name
      );
    }

    if (untrackedItems.length > 0) {
      clevertapLibraryList.libraryItemRemoveTrackingStockAlert(
        untrackedItems,
        values.item.name
      );
    }

    clevertapLibraryList.libraryItemUpdate(
      updatedItem,
      itemDetail,
      user,
      search,
      outlets
    );
    items.results[
      items.results.map(item => item.id).indexOf(values.item.id)
    ] = updatedItem;

    yield put(actItem.setItems(items));
    yield put(actItem.setItemDetail(updatedItem));
    yield put(
      actNotif.success(
        'Item was successfully updated.',
        yield getCloneOutletNotification()
      )
    );
    if (allOutlet) {
      if (responseUpdate.data.is_async_perform) {
        yield put(actItem.showSaveToAllOutletsModal());
      }
    }
    clevertapLibraryList.updateToAllOutletSuccess(
      values.item.id,
      values.item.name
    );
  } catch (error) {
    const { response } = error;
    if (response.data.code === '0007-0054') {
      yield put(actItem.showErrorUpdateAllOutletModal());
    } else {
      yield put(
        actNotif.error(
          error.response.data.message,
          yield getCloneOutletNotification()
        )
      );
      if (
        error.response.data.message &&
        error.response.data.message.includes('Sales type')
      ) {
        yield put(actItem.closeRightColumn());
      }
    }
    clevertapLibraryList.updateToAllOutletFailed(
      values.item.id,
      values.item.name,
      response.data.message
    );
  } finally {
    yield put(actItem.setIsSubmittingForm(false));
    yield put(act.hideProgressBar());
  }
}

function setSalesType(item, salesType) {
  const salesTypeIdList = salesType.map(st => st.id);

  const currentSalesType = [];
  if (item.is_sales_type_price) {
    salesType.forEach(st => {
      currentSalesType[st.id] = 0;
    });
  }
  item.item_variants.forEach(function(iv) {
    // change price to string to handle redux form isDirty
    iv.is_editable = !iv.is_saved;
    iv.saved_cogs = !(!iv.has_cogs && !iv.track_cogs);
    if (item.is_sales_type_price) {
      iv.sales_type_items.forEach((sti, index) => {
        if (
          salesTypeIdList.indexOf(iv.sales_type_items[index].sales_type_id) ===
          -1
        ) {
          delete iv.sales_type_items[index];
        } else {
          currentSalesType[sti.sales_type_id]++;
        }
      });
    }
    return iv;
  });
  return salesType.map(st => {
    return { ...st, selected: currentSalesType[st.id] > 0 };
  });
}

export function* onConfirmItemInventoryAlertModal(request) {
  const { value, itemForm } = request.payload;
  const itemVarCopy = itemForm.item_variants;
  yield put(arrayRemoveAll('item', 'item_variants'));
  for (let idx = 0; idx < value.item_variants.length; idx++) {
    if (value.item_variants[idx].track_cogs) {
      value.item_variants[idx].track_cogs =
        value.item_variants[idx].track_stock;
      if (
        !value.item_variants[idx].saved_cogs &&
        !value.item_variants[idx].track_cogs
      ) {
        value.item_variants[idx].cogs = null;
      }
    }
    yield put(
      arrayPush('item', 'item_variants', {
        ...value.item_variants[idx],
        is_saved: isSaved(value.item_variants[idx], itemVarCopy[idx]),
      })
    );
  }
  yield put(initialize('modal_item_variants', {}));
  yield put(actItem.hideItemInventoryAlertModal());
}

function isSaved(iv, civ) {
  return civ.is_saved || iv.track_stock;
}

export function* onConfirmCOGSModal(request) {
  const { value, isTrack } = request.payload;
  yield put(arrayRemoveAll('item', 'item_variants'));
  for (let idx = 0; idx < value.item_variants.length; idx++) {
    if (
      !value.item_variants[idx].saved_cogs &&
      !value.item_variants[idx].track_cogs
    ) {
      value.item_variants[idx].cogs = null;
    }
    yield put(arrayPush('item', 'item_variants', value.item_variants[idx]));
  }
  clevertapLibraryList.cogsTrackingItem({
    itemVariant: value.item_variants,
    cogsTrack: isTrack,
  });
  yield put(initialize('modal_item_variants', {}));
  yield put(actItem.hideCOGSModal());
}

export function* onRedirectSalesType() {
  browserHistory.push('/library/sales_type');
}

export function* deleteItem(request) {
  const {
    payload: { item, previousItems, search },
  } = request;
  try {
    yield put(act.showProgressBar());
    // remove items
    let deletedIndex = -1;
    previousItems.results.forEach((pitem, index) => {
      if (pitem.id === item.id) {
        deletedIndex = index;
      }
    });
    if (deletedIndex !== -1) {
      previousItems.results.splice(deletedIndex, 1);
    }
    yield call(apiItem.deleteItemByIdInventoryV1, item.id);
    yield call(closeRightColumn);
    yield put(actItem.setItemDetail(null));
    yield put(reset('item'));
    yield put(actItem.hideDeleteModal());
    const query = {
      page: 0,
      category_id: !parseInt(search.categoryId) ? '' : search.categoryId,
      inventory: !parseInt(search.typeInventoryId)
        ? 'all'
        : search.typeInventoryId === '1'
        ? 'low'
        : 'out',
      keyword: !search.search ? '' : search.search,
      outlet_id: search.outletIds[0],
    };
    const summary = yield call(fetchSummary, query); // todo refactor
    yield put(actItem.setItemSummary(summary));
    yield put(
      actNotif.success(
        'Item was successfully removed.',
        yield getCloneOutletNotification()
      )
    );
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* onClickCreateCategory(request) {
  const {
    payload: { category, previousCategories, previousCategoryId },
  } = request;
  yield put(actItem.setNewCategory(category));
  yield put(actItem.setPreviousCategories(previousCategories));
  // push new category since we want to 'manipulate' the view using redux,
  // using id == 0 as 'dummy id' for category
  const categories = [...previousCategories];
  categories.push({
    id: 0,
    name: category,
  });
  yield put(actItem.setCategories(categories));
  yield put(actItem.setPreviousCategoryId(previousCategoryId));
  // wait to make the event dispatched successfully propagated
  yield call(delay, 50);
  yield put(change('item', 'category_id', 0));
  if (category) {
    yield put(actItem.showNewCategoryModal());
  }
}

export function* onClickCreateBrand(request) {
  const {
    payload: { brand, previousBrand, previousBrandId },
  } = request;
  yield put(actItem.setNewBrand(brand));
  yield put(actItem.setPreviousBrand(previousBrand));
  const brands = [...previousBrand];
  brands.push({
    id: 0,
    name: brand,
  });
  yield put(actItem.setBrandList(brands));
  yield put(actItem.setPreviousBrandId(previousBrandId));
  yield call(delay, 50);
  yield put(change('item', 'brand_id', 0));
  yield put(actItem.showNewBrandModal());
}

export function* onClickCancelCreateCategory(request) {
  const {
    payload: { previousCategories, previousCategoryId },
  } = request;
  yield put(actItem.setCategories(previousCategories));
  yield put(change('item', 'category_id', previousCategoryId));
  yield put(actItem.hideNewCategoryModal());
}

export function* onClickConfirmCreateCategory(request) {
  const {
    payload: { category },
  } = request;
  try {
    yield put(act.showProgressBar());
    const createCategoryRes = yield call(apiCategory.createCategory, {
      name: category,
    });
    const categoriesRes = yield call(
      apiCategory.getCategoriesWithUncategorizedV1
    );
    yield put(actItem.setCategories(categoriesRes.data));
    yield put(change('item', 'category_id', createCategoryRes.data.id));
    yield put(
      actNotif.success(
        'Category successfully created.',
        yield getCloneOutletNotification()
      )
    );
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(actItem.hideNewCategoryModal());
  }
}

export function* onConfirmCreateBrand(request) {
  const {
    payload: { brand, outletId },
  } = request;
  try {
    yield put(act.showProgressBar());
    const { data: createdBrand } = yield call(
      apiItem.postBrand,
      { name: brand },
      outletId,
      { isUseExisting: true }
    );
    const params = { page: 0, size: 1000 };
    let {
      data: { results: listBrands },
    } = yield call(apiItem.getBrandList, params, outletId);
    let isFound = false;

    for (let i = 0; i < listBrands.length; i++) {
      if (listBrands[i].id === createdBrand.id) {
        isFound = true;
        break;
      }
    }

    if (!isFound) {
      listBrands = [...listBrands, createdBrand];
    }
    yield put(actItem.setBrandList(listBrands));
    yield put(change('item', 'brand_id', createdBrand.id));
    yield put(
      actNotif.success(
        'Brand successfully created.',
        yield getCloneOutletNotification()
      )
    );
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(actItem.hideNewBrandModal());
    yield put(actItem.setNewBrand(null));
    yield put(actItem.setPreviousBrand([]));
    yield put(actItem.setPreviousBrandId(null));
  }
}

export function* onSuccessImport() {
  yield put(actItem.hideImportModal());
  yield put(actItem.closeRightColumn());
  yield put(
    actNotif.success(
      'Item successfully imported',
      yield getCloneOutletNotification()
    )
  );
  yield put(actItem.pageRequest());
}

function constructEcommerceData(combineArray) {
  if (combineArray.length === 1) {
    return combineArray[0];
  }
  const result = [];
  const allCasesOfRest = constructEcommerceData(combineArray.slice(1)); // recur with the rest of array
  for (let i = 0; i < allCasesOfRest.length; i++) {
    for (let j = 0; j < combineArray[0].length; j++) {
      result.push(`${combineArray[0][j]} / ${allCasesOfRest[i]}`);
    }
  }
  return result;
}

function* getInventoryFeature() {
  try {
    const response = yield call(getInventoryFeatureFlag);
    return response.data.map(feature => {
      return feature.name;
    });
  } catch (err) {
    // avoid an error
    return [];
  }
}

export function* onSetCustomCategoryFashionData({ type }) {
  const customFashionCategoryData = yield select(
    getItemCustomCategoryEcommerceFashionData
  );

  const { colors, materials, sizes } = customFashionCategoryData;
  const itemVariantsForm = yield select(getFormItemVariants);
  const itemVariantsModalForm = yield select(getFormModalItemVariants);
  const customCategoryVariant = yield select(
    getFormModalItemVariantsCustomCategoryVariant
  );

  let itemVariantTempModalFormNonEcommerce = itemVariantsModalForm.filter(
    itemVariant => !itemVariant.is_generated
  );

  const itemVariantTempModalFormEcommerce = itemVariantsModalForm.filter(
    itemVariant => itemVariant.is_generated
  );

  yield put(arrayRemoveAll('modal_item_variants', 'item_variants'));

  const customCategoryEcommerceAttribute = yield select(
    getItemCustomCategoryEcommerceFashionAttribute
  );

  let data = {
    colors: colors.data,
    sizes: sizes.data,
    materials: materials.data,
  };

  if (
    type === 'LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_CONSTRUCT_DATA' &&
    customCategoryVariant &&
    (data.colors.length === 0 &&
      data.sizes.length === 0 &&
      data.materials.length === 0)
  ) {
    for (let i = 0; i < itemVariantsForm.length; i++) {
      if (itemVariantsForm[i].is_generated) {
        const splittedName = itemVariantsForm[i].name.split('/');
        const customCategoryDataPrevious = yield select(
          getItemCustomCategoryEcommerceFashionData
        );

        for (let j = 0; j < splittedName.length; j++) {
          const variantName = splittedName[j].trim();
          let categoryName;

          if (j === 0) {
            categoryName = `${
              customCategoryEcommerceAttribute.find(
                ({ name }) => name === 'color'
              ).name
            }s`;
          } else if (j === 1) {
            categoryName = `${
              customCategoryEcommerceAttribute.find(
                ({ name }) => name === 'size'
              ).name
            }s`;
          } else {
            categoryName = `${
              customCategoryEcommerceAttribute.find(
                ({ name }) => name === 'material'
              ).name
            }s`;
          }

          const isDuplicate = customCategoryDataPrevious[
            categoryName
          ].data.find(dat => dat === variantName);

          if (!isDuplicate) {
            const actionName = `setCustomCategoryFashion${categoryName[0].toUpperCase() +
              categoryName.slice(1, categoryName.length - 1)}DataNoSaga`;
            data = {
              ...data,
              [categoryName]: [...data[categoryName], variantName],
            };
            yield put(actItem[actionName](variantName));
          }
        }
      }
    }
  }

  let isEcommerceDataExist = false;

  if (
    data.colors.length > 0 &&
    data.sizes.length > 0 &&
    data.materials.length > 0
  ) {
    isEcommerceDataExist = true;
    const ecommerceDatas = constructEcommerceData([
      data.colors,
      data.sizes,
      data.materials,
    ]);

    for (let i = 0; i < ecommerceDatas.length; i++) {
      const ecommerceData = ecommerceDatas[i].split('/');
      let itemVariantEcommerceAttributes = [];

      const customCategoryEcommerceAttributeFiltered = customCategoryEcommerceAttribute.filter(
        ({ name }) => name === 'color' || name === 'size' || name === 'material'
      );

      customCategoryEcommerceAttributeFiltered.forEach(({ id, name }, j) => {
        let data = {
          ecommerce_attribute_id: id,
          ecommerce_attribute_name: name,
          value: ecommerceData[j].trim(),
        };

        let foundIvea;

        const foundItemVariant =
          type === 'LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_CONSTRUCT_DATA'
            ? itemVariantsForm.find(iv => iv.name === ecommerceDatas[i])
            : itemVariantTempModalFormEcommerce.find(
                iv => iv.name === ecommerceDatas[i]
              );

        if (
          foundItemVariant &&
          foundItemVariant.item_variant_ecommerce_attributes.length > 0
        ) {
          foundIvea = foundItemVariant.item_variant_ecommerce_attributes.find(
            ivea => ivea.ecommerce_attribute_id === id
          );
        }

        if (foundIvea) {
          data = { ...foundIvea, ...data };
        }

        itemVariantEcommerceAttributes = [
          ...itemVariantEcommerceAttributes,
          data,
        ];
      });

      const foundItemVariant =
        type === 'LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_CONSTRUCT_DATA'
          ? itemVariantsForm.find(iv => iv.name === ecommerceDatas[i])
          : itemVariantTempModalFormEcommerce.find(
              iv => iv.name === ecommerceDatas[i]
            );

      if (
        !foundItemVariant &&
        type === 'LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_CONSTRUCT_DATA'
      ) {
        continue;
      }

      let initialValue = {
        id:
          foundItemVariant && foundItemVariant.id ? foundItemVariant.id : null,
        name: ecommerceDatas[i],
        item_variant_ecommerce_attributes: itemVariantEcommerceAttributes,
        price: foundItemVariant ? foundItemVariant.price : null,
        sku: foundItemVariant ? foundItemVariant.sku : '',
        in_stock: foundItemVariant ? foundItemVariant.in_stock : 0,
        stock_alert: foundItemVariant ? foundItemVariant.stock_alert : 0,
        cogs: foundItemVariant ? foundItemVariant.cogs : null,
        saved_cogs: foundItemVariant ? foundItemVariant.saved_cogs : false,
        is_saved: foundItemVariant ? foundItemVariant.is_saved : false,
        is_new: foundItemVariant ? foundItemVariant.is_new : true,
        is_editable: foundItemVariant ? foundItemVariant.is_editable : true,
        is_generated: true,
        disabled: true,
        alert: foundItemVariant ? foundItemVariant.alert : false,
        track_stock: foundItemVariant ? foundItemVariant.track_stock : false,
      };

      if (foundItemVariant && foundItemVariant.track_cogs) {
        initialValue = {
          ...initialValue,
          track_cogs: foundItemVariant.track_cogs,
        };
      }

      if (foundItemVariant && foundItemVariant.sales_type_item_variants) {
        initialValue = {
          ...initialValue,
          sales_type_item_variants: foundItemVariant.sales_type_item_variants,
        };
      }

      const isSalesTypeOn = itemVariantsForm.find(iv => iv.sales_type_items);

      if (isSalesTypeOn) {
        initialValue = {
          ...initialValue,
          sales_type_items: isSalesTypeOn.sales_type_items,
        };
      }

      yield put(
        arrayPush('modal_item_variants', 'item_variants', initialValue)
      );
    }
  }

  if (isEcommerceDataExist) {
    itemVariantTempModalFormNonEcommerce = itemVariantTempModalFormNonEcommerce.filter(
      itemVariant =>
        itemVariant.price || itemVariant.sku || itemVariant.name !== ''
    );
  } else if (itemVariantTempModalFormNonEcommerce.length === 0) {
    const initialValue = {
      name: '',
      price: null,
      sku: '',
      in_stock: 0,
      stock_alert: 0,
      cogs: null,
      saved_cogs: false,
      is_saved: false,
      is_editable: true,
      is_new: true,
    };
    itemVariantTempModalFormNonEcommerce = [initialValue];
  }

  yield all(
    itemVariantTempModalFormNonEcommerce.map(itemVariant =>
      put(arrayPush('modal_item_variants', 'item_variants', itemVariant))
    )
  );
}

export default function* libraryItemSaga() {
  yield takeLatest(LIBRARY_ITEM_SET_FILTER_ITEM, setFilterItem);
  yield takeLatest(LIBRARY_ITEM_PAGE_REQUEST, pageRequestFlow);
  yield takeLatest(LIBRARY_ITEM_ON_CHANGE_OUTLET_IDS, onChangeOutletIds);
  yield takeLatest(LIBRARY_ITEM_LIST_ITEM_REQUEST, itemsRequest);
  yield takeLatest(LIBRARY_ITEM_ITEM_LIST_EXPORT, getExportItem);
  yield takeLatest(LIBRARY_ITEM_ITEM_LIST_TEMPLATE, downloadItemsTemplate);
  yield takeLatest(LIBRARY_ITEM_ON_CLICK_CANCEL, clickCancel);
  yield takeLatest(
    LIBRARY_ITEM_ON_CLICK_BTN_ITEM_VARIANT,
    onClickBtnItemVariant
  );
  yield takeLatest(
    LIBRARY_ITEM_ON_CANCEL_ITEM_VARIANT_MODAL,
    onCancelItemVariantModal
  );
  yield takeLatest(
    LIBRARY_ITEM_ON_CONFIRM_ITEM_VARIANT_MODAL,
    onConfirmItemVariantModal
  );
  yield takeLatest(
    LIBRARY_ITEM_ON_CONFIRM_SALES_TYPE_MODAL,
    onConfirmSalesTypeModal
  );
  yield takeLatest(LIBRARY_ITEM_ON_CLICK_BTN_SALES_TYPE, onClickBtnSalesType);
  yield takeLatest(
    LIBRARY_ITEM_ON_CANCEL_SALES_TYPE_MODAL,
    onCancelSalesTypeModal
  );
  yield takeLatest(
    LIBRARY_ITEM_ON_CLICK_BTN_ITEM_TRACKING,
    onClickBtnItemTracking
  );
  yield takeLatest(
    LIBRARY_ITEM_ON_CLICK_BTN_COGS_TRACKING,
    onClickBtnCOGSTracking
  );
  yield takeLatest(
    LIBRARY_ITEM_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL,
    onCancelItemInventoryAlertModal
  );
  yield takeLatest(LIBRARY_ITEM_ON_CANCEL_COGS_MODAL, onCancelCOGSModal);
  yield takeLatest(
    LIBRARY_ITEM_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL,
    onConfirmItemInventoryAlertModal
  );
  yield takeLatest(LIBRARY_ITEM_ON_CONFIRM_COGS_MODAL, onConfirmCOGSModal);
  yield takeLatest(LIBRARY_ITEM_FILL_FORM_DETAIL_ITEM, fillFormDetail);
  yield fork(getCategoriesWithUncategorizedFlow);
  yield takeLatest(LIBRARY_ITEM_SUBMIT_FORM_CREATE, submitFormCreate);
  yield takeLatest(LIBRARY_ITEM_SUBMIT_FORM_UPDATE, submitFormUpdate);
  yield takeLatest(LIBRARY_ITEM_DELETE_ITEM, deleteItem);
  yield takeLatest(
    LIBRARY_ITEM_ON_CLICK_CREATE_NEW_CATEGORY,
    onClickCreateCategory
  );
  yield takeLatest(LIBRARY_ITEM_ON_CLICK_CREATE_NEW_BRAND, onClickCreateBrand);
  yield takeLatest(
    LIBRARY_ITEM_CONFIRM_CREATE_NEW_CATEGORY,
    onClickConfirmCreateCategory
  );
  yield takeLatest(
    LIBRARY_ITEM_CANCEL_CREATE_NEW_CATEGORY,
    onClickCancelCreateCategory
  );
  yield takeLatest(LIBRARY_ITEM_ON_SUCCESS_IMPORT, onSuccessImport);
  yield takeLatest(LIBRARY_ITEM_ON_REDIRECT_SALES_TYPE, onRedirectSalesType);
  yield takeLatest(LIBRARY_ITEM_ITEM_LIST_EXPORT_FINISHED, itemExportFinished);
  yield takeLatest(LIBRARY_ITEM_ITEM_LIST_EXPORT_ERROR, itemExportError);
  yield takeLatest(LIBRARY_ITEM_CONFIRM_CREATE_NEW_BRAND, onConfirmCreateBrand);
  yield takeLatest(
    [
      LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_CONSTRUCT_DATA,
      LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_SIZE_DATA,
      LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_DATA,
      LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_ALL_DATA,
      LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_COLOR_DATA,
      LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_DATA,
      LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_ALL_DATA,
      LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA,
      LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA,
      LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_ALL_DATA,
    ],
    onSetCustomCategoryFashionData
  );
}
